import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

export function RoomPersonalizationKeepExistingLabel() {
  const { t } = useTranslation();
  return <Text type="success">{t('personalization.keepExisting.keep')}</Text>;
}
